import * as angular from "angular";
import {IController} from "angular";

export class UrgencyTimeAndDateComponent implements IController {
  start: any;
  end: any;
  urgency: any;

  urgencyColors: any = {
    Other: 'grey-400',
    Normal: 'blue-grey-300',
    Urgent: 'deep-orange-300',
    Rush: 'red-300'
  };
  class: any;
  urgencyTime: any;

  constructor() {
  }

  $onInit() {
    this.class = this.urgencyColors[this.urgency] || 'grey-400';
  };

  $onChanges(changes) {
    if (changes.urgency && !changes.urgency.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('urgencyTimeAndDate', {
    bindings: {
      start: '<',
      end: '<',
      urgency: '<'
    },
    templateUrl: 'app/modules/commons/components/urgency-time-and-date/urgency-time-and-date.html',
    controller: UrgencyTimeAndDateComponent
  });
